import { DFSValueType } from './form';
import { $map } from './arrayExpressions';
import { $and, $exists, $not, $or, $cond, $equals, $gt, $gte, $lt, $lte, $contains, $regex } from './boolExpressions';
import { $date, $dateOffset, $dateFormat } from './dateExpressions';
import { $count, $sum, $sub, $multiply, $div, $ceil, $floor, $round, $min, $max, $strlen } from './numericExpressions';
import { ProcessorFunction } from './processor';
import { $join, $uuid } from './stringExpressions';

export const functions: { [expType: string]: ProcessorFunction<any, DFSValueType>;} = {
  $and: $and,
  $exists: $exists,
  $join: $join,
  $map: $map,
  $not: $not,
  $or: $or,
  $cond: $cond,
  $count: $count,
  $date: $date,
  $dateOffset: $dateOffset,
  $dateFormat: $dateFormat,
  "$+": $sum,
  "$-": $sub,
  "$*": $multiply,
  "$/": $div,
  "$==": $equals,
  $ceil: $ceil,
  $floor: $floor,
  $round: $round,
  "$>": $gt,
  "$>=": $gte,
  "$<": $lt,
  "$<=": $lte,
  $min: $min,
  $max: $max,
  $contains: $contains,
  $strlen: $strlen,
  $regex: $regex,
  $uuid: $uuid
};
